import Vue from 'vue'
import App from './App.vue'
// import 'github-markdown-css/github-markdown-light.css';
import './components/markdown.css'
import highlight from 'highlight.js'
import "highlight.js/styles/googlecode.css";

Vue.use(highlight)
Vue.config.productionTip = false

Vue.directive('highlight', (el) => {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    highlight.highlightBlock(block)
  })
})

new Vue({
  render: h => h(App),
}).$mount('#app')
